import { render, staticRenderFns } from "./visitHistory.vue?vue&type=template&id=5b5392fd&scoped=true"
import script from "./visitHistory.vue?vue&type=script&lang=js"
export * from "./visitHistory.vue?vue&type=script&lang=js"
import style0 from "./visitHistory.vue?vue&type=style&index=0&id=5b5392fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5392fd",
  null
  
)

export default component.exports